import FilterQuery, { Operator } from "../queries/FilterQuery";
import { IFilter } from "./IFilter";

export default class StringFilter implements IFilter {
  attribute: string;
  value: string;

  constructor(attribute: string, value: string) {
    this.attribute = attribute;
    this.value = value;
  }

  toQuery() {
    return new FilterQuery(this.attribute, Operator.LIKE, this.value);
  }
}
